export default "__VITE_ASSET__DFsFVbH1__"